import { render, staticRenderFns } from "./Dashboard-bmw.vue?vue&type=template&id=83c050fe&scoped=true&"
import script from "./Dashboard-bmw.vue?vue&type=script&lang=js&"
export * from "./Dashboard-bmw.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-bmw.vue?vue&type=style&index=0&id=83c050fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c050fe",
  null
  
)

export default component.exports